module.exports = ".login {\n    margin: 0 auto;\n}\n\n.message {\n    padding: 25px;\n    text-align: center;\n    font-size: 15px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.css
// module id = ./src/app/components/login/login.component.css
// module chunks = main